import {useSelector} from "react-redux";
import LogUtils from "../libs/LogUtils";


const useRoles = (module) => {
    const {role} = useSelector(state => state.auth);
    const rolePermissions = role.permissions;
    const modulePermissions = rolePermissions.find(item => item.module === module);
    return {
        canCreate: modulePermissions ? modulePermissions.create : false,
        canDelete: modulePermissions ? modulePermissions.delete : false,
        canRead: modulePermissions ? modulePermissions.read : false,
        canUpdate: modulePermissions ? modulePermissions.update : false,
        canAllData: modulePermissions ? modulePermissions.is_all_data : false,
    }
};

export default useRoles;
